import React from 'react';
import { Segment, Header, Image, Icon } from 'semantic-ui-react';
import profileReal from '../images/profile.jpg';
import profilePublic from '../images/profile_public.jfif';

function ProfileSection({ profileData, isPublic, lang }) {
  return (
    <Segment>
      <div className="profile-hero">
      <div className="profile-intro">
      <p className="profile-eyebrow"><span />{lang ? '欢迎来到我的数字空间' : 'WELCOME TO MY DIGITAL SPACE'}</p>
      <Header as="h1" className="profile-heading">
        <Header.Content>{isPublic ? (lang ? '猫猫' : 'Cat Meow') : profileData.name}<span className="profile-name-dot">.</span></Header.Content>
      </Header>
      <p className="profile-description">{lang ? '经历、想法与项目。持续探索，不断创造。' : 'A collection of experiences, ideas, and things I’ve built. Always exploring. Always creating.'}</p>
      <div className="profile-links">
        <a href={isPublic ? 'mailto:someone@gmail.com' : 'mailto:' + profileData.email}><Icon name="mail" />{lang ? '联系我' : 'Get in touch'}<Icon name="arrow right" /></a>
        <a href={isPublic ? 'https://github.com/ericpzh' : profileData.github}><Icon name="github" />GitHub<Icon name="external alternate" /></a>
      </div>
      </div>
      <div className="profile-portrait">
        <div className="portrait-orbit" aria-hidden="true"><span /></div>
        <span style={{ display: 'inline-block' }}>
          <Image circular size="medium" alt={isPublic ? 'Cat Meow' : profileData.name} src={isPublic ? profilePublic : profileReal} />
        </span>
        <span className="portrait-caption"><Icon name="terminal" />hello, world<span className="portrait-cursor" aria-hidden="true">_</span></span>
      </div>
      </div>
    </Segment>
  );
}

export default ProfileSection;
